// extracted by mini-css-extract-plugin
module.exports = {"mapPlaceholder":"Main_mapPlaceholder__2sqoq","flexMain":"Main_flexMain__MgcoX"};